import { useTranslation } from "react-i18next";
import { Button } from "../../../components";
import { TransactionDetailProps } from "./TransactionDetailProps";
import { formatDate, formatTime } from "../../history.utils";
import useWindowDimensions, { CurrentScreen } from "../../../../../hooks/use-window-dimensions";
import styles from "../customer-transaction-history-detail.module.scss";
import { CopyIcon } from "../../../../../assets/icons";
import { formatCurrency, handleCopy } from "../../../../../utils";
import { TransactionReceiptHeader } from "./TransactionReceiptHeader";

export const BillingTransactionDetail = ({
  transaction,
  onDownloadReceipt,
  isDownloading,
  shareView
}: TransactionDetailProps) => {
  const { t } = useTranslation();
  const currentScreen: CurrentScreen = useWindowDimensions();

  return (
    <>
      
      <div className={styles.detailsCard}>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("history.distributionCompany")}</span>
          <span className={styles.detailValue}>{transaction.billingDetails?.utility?.name ?? t("history.web.notApplicable")}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.accountNumber")}</span>
          <span className={styles.detailValue}>{transaction.billingDetails?.accountNumber ?? t("history.web.notApplicable")}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.meterNumber")}</span>
          <span className={styles.detailValue}>{transaction.billingDetails?.meterNumber ?? t("history.web.notApplicable")}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.customerName")}</span>
          <span className={styles.detailValue}>{transaction.billingDetails?.accountName ?? t("history.web.notApplicable")}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("history.serviceAddress")}</span>
          <span className={styles.detailValue}>{transaction.billingDetails?.address ?? t("history.web.notApplicable")}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("history.tariff")}</span>
          <span className={styles.detailValue}>{transaction.billingDetails?.tariffDescription ?? t("history.web.notApplicable")}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.amount")}</span>
          <span className={styles.detailValue}>{formatCurrency(transaction.billingDetails?.amount?.amount ?? 0, { currency: transaction.billingDetails?.amount?.currency })}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.outstandingBalance")}</span>
          <span className={styles.detailValue}>{formatCurrency(transaction.billingDetails?.previousOutstandingBalance?.amount ?? 0, { currency: transaction.billingDetails?.previousOutstandingBalance?.currency })}</span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.date")}</span>
          <span className={styles.detailValue}>{formatDate(transaction.createdAt)}, {formatTime(transaction.createdAt).toLocaleLowerCase()}</span>
        </div>
      </div>

      <div className={styles.footer}>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("history.web.transactionId")}</span>
          <div className={styles.copyContainer}>
            <span className={styles.detailValue}>{transaction.reference}</span>
            <CopyIcon onClick={() => handleCopy(transaction.reference)
            } className={styles.copyBtn} />
          </div>

        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("history.web.requestId")}</span>
          <div className={styles.copyContainer}>
            <span className={styles.detailValue}>{transaction.externalReference}</span>
            <CopyIcon onClick={() => handleCopy(transaction.externalReference)} className={styles.copyBtn} />
          </div>
        </div>
      </div>
    </>
  );
};
